

export class TemperatureStatusInput implements ITemperatureStatusInput {
    /** The auto-generated id of the temperature master */
    selectedTemperatureId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITemperatureStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedTemperatureId = _data["selectedTemperatureId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TemperatureStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedTemperatureId"] = this.selectedTemperatureId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITemperatureStatusInput {
    /** The auto-generated id of the temperature master */
    selectedTemperatureId: number;
    /** The updated status */
    status: number;
}

